import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable } from 'components/basic'
import FlowView from 'components/core/FlowView'
import { notify } from 'helpers'
import moment from 'moment'
import http from 'API/http'

class OrderEventsOverview extends FlowView {
  constructor (props) {
    super(props, 'Order Events')
    this.state = {
      events: [],
      loading: true
    }
  }
  async componentDidMount () {
    var err, res
    [err, res] = await http.get('2.4/orderevents/')
    if (err) return notify.alert('', err.cause, 'error')
    this.setState({events: res.data, loading: false})
  }

  fromOrderState (state) {
    switch (state) {
      case 'DONE_SUCCESS':
        return <span className='label orders-label label-success'><b>{state}</b></span>
      case 'RECEIVED':
        return <span className='label orders-label label-primary'><b>{state}</b></span>
      case 'IN_PROGRESS':
        return <span className='label orders-label label-warning'><b>{state}</b></span>
      case 'DONE_FAILED':
        return <span className='label orders-label label-danger'><b>{state}</b></span>
      default:
    }
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Events' subtitle='Overview' icon='fa-sliders' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='sliders' title='Events'>
            <FlowTable paginatable={20} loading={this.state.loading} data={
                this.state.events.map(event => [
                {onClick: e => (window.location.href = '/#/access/' + event.order.accessId)},
                  <a href={'/#/access/' + event.order.accessId} className='table-link'><i className='fa fa-folder-open-o' /></a>,
                  this.fromOrderState(event.order.state),
                  event.order.operation,
                  event.order.service,
                  event.order.message,
                  moment(event.timestamp).format('YYYY-MM-DD HH:mm:ss'),
                  event.event
                ])}>
              <tr>
                <th className='buttons' />
                <th style={{'width': '120px'}}>State</th>
                <th className='buttons'>Operation</th>
                <th>Service</th>
                <th>Message</th>
                <th>Time</th>
                <th>ID</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
OrderEventsOverview = connect(state => state.siteReducer)(OrderEventsOverview)
export default OrderEventsOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.4/orderevents/overview.js